module.exports = __webpack_public_path__ + "img/T750.8971fa86.jpg";